'use client';
import * as React from 'react';
import React__default, { forwardRef, useImperativeHandle, useRef, useCallback, useMemo, useEffect, useState } from 'react';
import { ThemeContext } from '../Theme';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var DefaultContext = {
  color: undefined,
  size: undefined,
  className: undefined,
  style: undefined,
  attr: undefined
};
var IconContext = React__default.createContext && /*#__PURE__*/React__default.createContext(DefaultContext);

var _excluded = ["attr", "size", "title"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function Tree2Element(tree) {
  return tree && tree.map((node, i) => /*#__PURE__*/React__default.createElement(node.tag, _objectSpread({
    key: i
  }, node.attr), Tree2Element(node.child)));
}
function GenIcon(data) {
  // eslint-disable-next-line react/display-name
  return props => /*#__PURE__*/React__default.createElement(IconBase, _extends({
    attr: _objectSpread({}, data.attr)
  }, props), Tree2Element(data.child));
}
function IconBase(props) {
  var elem = conf => {
    var {
        attr,
        size,
        title
      } = props,
      svgProps = _objectWithoutProperties(props, _excluded);
    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className) className = conf.className;
    if (props.className) className = (className ? className + " " : "") + props.className;
    return /*#__PURE__*/React__default.createElement("svg", _extends({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className: className,
      style: _objectSpread(_objectSpread({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && /*#__PURE__*/React__default.createElement("title", null, title), props.children);
  };
  return IconContext !== undefined ? /*#__PURE__*/React__default.createElement(IconContext.Consumer, null, conf => elem(conf)) : elem(DefaultContext);
}

// THIS FILE IS AUTO GENERATED
function HiEyeSlash (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M3.53 2.47a.75.75 0 00-1.06 1.06l18 18a.75.75 0 101.06-1.06l-18-18zM22.676 12.553a11.249 11.249 0 01-2.631 4.31l-3.099-3.099a5.25 5.25 0 00-6.71-6.71L7.759 4.577a11.217 11.217 0 014.242-.827c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113z"},"child":[]},{"tag":"path","attr":{"d":"M15.75 12c0 .18-.013.357-.037.53l-4.244-4.243A3.75 3.75 0 0115.75 12zM12.53 15.713l-4.243-4.244a3.75 3.75 0 004.243 4.243z"},"child":[]},{"tag":"path","attr":{"d":"M6.75 12c0-.619.107-1.213.304-1.764l-3.1-3.1a11.25 11.25 0 00-2.63 4.31c-.12.362-.12.752 0 1.114 1.489 4.467 5.704 7.69 10.675 7.69 1.5 0 2.933-.294 4.242-.827l-2.477-2.477A5.25 5.25 0 016.75 12z"},"child":[]}]})(props);
}function HiEye (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M12 15a3 3 0 100-6 3 3 0 000 6z"},"child":[]},{"tag":"path","attr":{"fillRule":"evenodd","d":"M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 010-1.113zM17.25 12a5.25 5.25 0 11-10.5 0 5.25 5.25 0 0110.5 0z","clipRule":"evenodd"},"child":[]}]})(props);
}function HiMagnifyingGlass (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M10.5 3.75a6.75 6.75 0 100 13.5 6.75 6.75 0 000-13.5zM2.25 10.5a8.25 8.25 0 1114.59 5.28l4.69 4.69a.75.75 0 11-1.06 1.06l-4.69-4.69A8.25 8.25 0 012.25 10.5z","clipRule":"evenodd"},"child":[]}]})(props);
}function HiMinus (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M3.75 12a.75.75 0 01.75-.75h15a.75.75 0 010 1.5h-15a.75.75 0 01-.75-.75z","clipRule":"evenodd"},"child":[]}]})(props);
}function HiPlus (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M12 3.75a.75.75 0 01.75.75v6.75h6.75a.75.75 0 010 1.5h-6.75v6.75a.75.75 0 01-1.5 0v-6.75H4.5a.75.75 0 010-1.5h6.75V4.5a.75.75 0 01.75-.75z","clipRule":"evenodd"},"child":[]}]})(props);
}

function Base(props) {
    var _a = props.required, required = _a === void 0 ? false : _a, _b = props.disabled, disabled = _b === void 0 ? false : _b, _c = props.readOnly, readOnly = _c === void 0 ? false : _c, _d = props.className, className = _d === void 0 ? "w-full p-2 border rounded " : _d;
    var handleInput = function (e) {
        props.onInput && props.onInput(e);
    };
    var handleChange = function (e) {
        props.onChange && props.onChange(e);
    };
    var handleBlur = function (e) {
        props.onBlur && props.onBlur(e);
    };
    return (React.createElement("input", { type: props.type, id: props.id, name: props.name, placeholder: props.placeholder, style: props.style, className: className, defaultValue: props.defaultValue, value: props.value, required: required, disabled: disabled, readOnly: readOnly, onInput: handleInput, onChange: handleChange, onBlur: handleBlur }));
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$3 = ".InputCounter-module_input-counter__zx-Ff::-webkit-inner-spin-button,\r\n::-webkit-outer-spin-button {\r\n  -webkit-appearance: none;\r\n  margin: 0;\r\n}\r\n\r\n.InputCounter-module_input-counter__zx-Ff:focus {\r\n  outline: none;\r\n}";
var styles$1 = {"input-counter":"InputCounter-module_input-counter__zx-Ff"};
styleInject(css_248z$3);

var InputTheme;
(function (InputTheme) {
    InputTheme["ALLIEDCONTAINER"] = "acem";
    InputTheme["ALLIEDCONTAINER2"] = "acem2";
    InputTheme["ACSMARINE"] = "acsm";
})(InputTheme || (InputTheme = {}));
var InputSize;
(function (InputSize) {
    InputSize["LARGE"] = "lg";
    InputSize["MEDIUM"] = "md";
})(InputSize || (InputSize = {}));

var themes$6 = new Map();
var defaultTheme$6 = new Map();
defaultTheme$6.set("container", "flex flex-row rounded outline outline-1 outline-slate-100");
defaultTheme$6.set("element", styles$1['input-counter'] + " w-full border text-center");
defaultTheme$6.set("disabled-true", "cursor-not-allowed");
defaultTheme$6.set("size-".concat(InputSize.LARGE), "px-2 py-3");
defaultTheme$6.set("size-".concat(InputSize.MEDIUM), "p-2");
var acem2Theme$6 = new Map();
acem2Theme$6.set("container", "flex flex-row rounded outline outline-1 outline-acem2-asphalt");
acem2Theme$6.set("element", styles$1['input-counter'] + " w-full border text-center");
acem2Theme$6.set("disabled-true", "cursor-not-allowed");
acem2Theme$6.set("size-".concat(InputSize.LARGE), "px-2 py-3");
acem2Theme$6.set("size-".concat(InputSize.MEDIUM), "p-2");
themes$6.set("", defaultTheme$6);
themes$6.set(InputTheme.ALLIEDCONTAINER2, acem2Theme$6);
var InputCounterStyle = /** @class */ (function () {
    function InputCounterStyle() {
        this.theme = "";
        this.disabled = false;
        this.size = "";
        this.elementClassNames = "";
    }
    InputCounterStyle.prototype.buildElement = function () {
        var style = undefined;
        if (this.elementClassNames) {
            return this.elementClassNames;
        }
        var theme = themes$6.get(this.theme);
        if (!theme) {
            return style;
        }
        if (theme.has("element")) {
            style = theme.get("element");
        }
        if (theme.has("disabled-".concat(this.disabled))) {
            style += " " + theme.get("disabled-".concat(this.disabled));
        }
        if (theme.has("size-".concat(this.size))) {
            style += " " + theme.get("size-".concat(this.size));
        }
        return style;
    };
    InputCounterStyle.prototype.buildContainer = function () {
        var style = undefined;
        var theme = themes$6.get(this.theme);
        if (!theme) {
            return style;
        }
        if (theme.has("container")) {
            style = theme.get("container");
        }
        return style;
    };
    InputCounterStyle.prototype.setTheme = function (theme) {
        this.theme = theme;
        return this;
    };
    InputCounterStyle.prototype.setDisabled = function (disabled) {
        this.disabled = disabled;
        return this;
    };
    InputCounterStyle.prototype.setSize = function (size) {
        this.size = size;
        return this;
    };
    InputCounterStyle.prototype.setElementClassNames = function (elementClassNames) {
        this.elementClassNames = elementClassNames;
        return this;
    };
    return InputCounterStyle;
}());
var styleBuilder$6 = new InputCounterStyle();
function InputCounter(props) {
    var themeCtx = React.useContext(ThemeContext);
    var _a = props.disabled, disabled = _a === void 0 ? false : _a, _b = props.size, size = _b === void 0 ? InputSize.MEDIUM : _b, _c = props.value, value = _c === void 0 ? 0 : _c, className = props.className, style = props.style;
    var _d = props.theme, theme = _d === void 0 ? themeCtx.theme || "" : _d;
    if (!themes$6.has(theme)) {
        theme = "";
    }
    styleBuilder$6
        .setTheme(theme)
        .setElementClassNames(className)
        .setDisabled(disabled)
        .setSize(size);
    var containerClassNames = styleBuilder$6.buildContainer();
    var elementClassNames = styleBuilder$6.buildElement();
    var handleDecrease = function () {
        props.onDecrease && props.onDecrease();
    };
    var handleIncrease = function () {
        props.onIncrease && props.onIncrease();
    };
    var handleInput = function (e) {
        var val = e.currentTarget.value;
        updateValue(val);
    };
    var handleChange = function (e) {
        var val = e.currentTarget.value;
        updateValue(val);
    };
    function updateValue(val) {
        if (!props.onUpdate) {
            return;
        }
        if (!val) {
            props.onUpdate({
                value: Number(0),
            });
            return;
        }
        val = val.replace(/[^0-9-]/g, "");
        if (val === "-") {
            props.onUpdate({
                value: Number(-1),
            });
            return;
        }
        props.onUpdate({
            value: Number(val),
        });
    }
    return (React.createElement("div", { className: containerClassNames },
        React.createElement("button", { type: "button", className: "bg-white p-2 border rounded-tl rounded-bl", onClick: handleDecrease },
            React.createElement(HiMinus, { className: "w-6 h-6", "aria-hidden": "true" })),
        React.createElement(Base, __assign({ type: "number", value: value, onInput: handleInput, className: elementClassNames, onChange: handleChange, style: style }, props)),
        React.createElement("button", { type: "button", className: "bg-white p-2 border rounded-tr rounded-br", onClick: handleIncrease },
            React.createElement(HiPlus, { className: "w-6 h-6", "aria-hidden": "true" }))));
}

var themes$5 = new Map();
var defaultTheme$5 = new Map();
defaultTheme$5.set("element", "w-full border rounded outline outline-1 outline-slate-100");
defaultTheme$5.set("disabled-true", "cursor-not-allowed");
defaultTheme$5.set("size-".concat(InputSize.LARGE), "px-2 py-3");
defaultTheme$5.set("size-".concat(InputSize.MEDIUM), "p-2");
var acsmTheme$3 = new Map();
acsmTheme$3.set("element", "w-full border-b border-black placeholder:text-acsm-red font-verdana sm:!font-poppins");
acsmTheme$3.set("disabled-true", "cursor-not-allowed");
acsmTheme$3.set("size-".concat(InputSize.LARGE), "px-2 py-3");
acsmTheme$3.set("size-".concat(InputSize.MEDIUM), "p-2");
var acem2Theme$5 = new Map();
acem2Theme$5.set("element", "w-full border rounded outline outline-1 outline-acem2-asphalt");
acem2Theme$5.set("disabled-true", "cursor-not-allowed");
acem2Theme$5.set("size-".concat(InputSize.LARGE), "px-2 py-3");
acem2Theme$5.set("size-".concat(InputSize.MEDIUM), "p-2");
themes$5.set("", defaultTheme$5);
themes$5.set(InputTheme.ACSMARINE, acsmTheme$3);
themes$5.set(InputTheme.ALLIEDCONTAINER2, acem2Theme$5);
var InputEmailStyle = /** @class */ (function () {
    function InputEmailStyle() {
        this.theme = "";
        this.disabled = false;
        this.size = "";
        this.elementClassNames = "";
        this.appendedClassNames = "";
    }
    InputEmailStyle.prototype.buildElement = function () {
        var style = undefined;
        if (this.elementClassNames) {
            return this.elementClassNames;
        }
        var theme = themes$5.get(this.theme);
        if (!theme) {
            return style;
        }
        if (theme.has("element")) {
            style = theme.get("element");
        }
        if (theme.has("disabled-".concat(this.disabled))) {
            style += " " + theme.get("disabled-".concat(this.disabled));
        }
        if (theme.has("size-".concat(this.size))) {
            style += " " + theme.get("size-".concat(this.size));
        }
        if (this.appendedClassNames && this.appendedClassNames !== "") {
            style += " " + this.appendedClassNames;
        }
        return style;
    };
    InputEmailStyle.prototype.setTheme = function (theme) {
        this.theme = theme;
        return this;
    };
    InputEmailStyle.prototype.setDisabled = function (disabled) {
        this.disabled = disabled;
        return this;
    };
    InputEmailStyle.prototype.setSize = function (size) {
        this.size = size;
        return this;
    };
    InputEmailStyle.prototype.setElementClassNames = function (elementClassNames) {
        this.elementClassNames = elementClassNames;
        return this;
    };
    InputEmailStyle.prototype.setAppendedClassNames = function (appendedClassNames) {
        this.appendedClassNames = appendedClassNames;
        return this;
    };
    return InputEmailStyle;
}());
var styleBuilder$5 = new InputEmailStyle();
function InputEmail(props) {
    var themeCtx = React.useContext(ThemeContext);
    var _a = props.disabled, disabled = _a === void 0 ? false : _a, _b = props.size, size = _b === void 0 ? InputSize.MEDIUM : _b, appendClassNames = props.appendClassNames, className = props.className;
    var _c = props.theme, theme = _c === void 0 ? themeCtx.theme || "" : _c;
    if (!themes$5.has(theme)) {
        theme = "";
    }
    styleBuilder$5
        .setTheme(theme)
        .setElementClassNames(className)
        .setAppendedClassNames(appendClassNames)
        .setDisabled(disabled)
        .setSize(size);
    var elementClassNames = styleBuilder$5.buildElement();
    return React.createElement(Base, __assign({ type: "email", className: elementClassNames }, props));
}

var css_248z$2 = ".InputNumber-module_input-number__o60cr::-webkit-inner-spin-button,\r\n::-webkit-outer-spin-button {\r\n  -webkit-appearance: none;\r\n  margin: 0;\r\n}\r\n\r\n.InputNumber-module_input-number__o60cr:focus {\r\n  outline: none;\r\n}";
var styles = {"input-number":"InputNumber-module_input-number__o60cr"};
styleInject(css_248z$2);

var themes$4 = new Map();
var defaultTheme$4 = new Map();
defaultTheme$4.set("", styles['input-number'] + " w-full border rounded outline outline-1 outline-slate-100");
defaultTheme$4.set("disabled-true", "cursor-not-allowed");
defaultTheme$4.set("size-".concat(InputSize.LARGE), "px-2 py-3");
defaultTheme$4.set("size-".concat(InputSize.MEDIUM), "p-2");
var acsmTheme$2 = new Map();
acsmTheme$2.set("", styles['input-number'] + " w-full border-b border-black placeholder:text-acsm-red font-verdana sm:!font-poppins");
acsmTheme$2.set("disabled-true", "cursor-not-allowed");
acsmTheme$2.set("size-".concat(InputSize.LARGE), "px-2 py-3");
acsmTheme$2.set("size-".concat(InputSize.MEDIUM), "p-2");
var acem2Theme$4 = new Map();
acem2Theme$4.set("", styles['input-number'] + " w-full border rounded outline outline-1 outline-acem2-asphalt");
acem2Theme$4.set("disabled-true", "cursor-not-allowed");
acem2Theme$4.set("size-".concat(InputSize.LARGE), "px-2 py-3");
acem2Theme$4.set("size-".concat(InputSize.MEDIUM), "p-2");
themes$4.set("", defaultTheme$4);
themes$4.set(InputTheme.ACSMARINE, acsmTheme$2);
themes$4.set(InputTheme.ALLIEDCONTAINER2, acem2Theme$4);
var InputNumberStyle = /** @class */ (function () {
    function InputNumberStyle() {
        this.theme = "";
        this.disabled = false;
        this.size = "";
        this.elementClassNames = "";
        this.appendedClassNames = "";
    }
    InputNumberStyle.prototype.buildElement = function () {
        var style = undefined;
        if (this.elementClassNames) {
            return this.elementClassNames;
        }
        var theme = themes$4.get(this.theme);
        if (!theme) {
            return style;
        }
        if (theme.has("")) {
            style = theme.get("");
        }
        if (theme.has("disabled-".concat(this.disabled))) {
            style += " " + theme.get("disabled-".concat(this.disabled));
        }
        if (theme.has("size-".concat(this.size))) {
            style += " " + theme.get("size-".concat(this.size));
        }
        if (this.appendedClassNames && this.appendedClassNames !== "") {
            style += " " + this.appendedClassNames;
        }
        return style;
    };
    InputNumberStyle.prototype.setTheme = function (theme) {
        this.theme = theme;
        return this;
    };
    InputNumberStyle.prototype.setDisabled = function (disabled) {
        this.disabled = disabled;
        return this;
    };
    InputNumberStyle.prototype.setSize = function (size) {
        this.size = size;
        return this;
    };
    InputNumberStyle.prototype.setElementClassNames = function (elementClassNames) {
        this.elementClassNames = elementClassNames;
        return this;
    };
    InputNumberStyle.prototype.setAppendedClassNames = function (appendedClassNames) {
        this.appendedClassNames = appendedClassNames;
        return this;
    };
    return InputNumberStyle;
}());
var styleBuilder$4 = new InputNumberStyle();
function InputNumber(props) {
    var themeCtx = React.useContext(ThemeContext);
    var _a = props.disabled, disabled = _a === void 0 ? false : _a, _b = props.size, size = _b === void 0 ? InputSize.MEDIUM : _b, appendClassNames = props.appendClassNames, className = props.className, style = props.style;
    var _c = props.theme, theme = _c === void 0 ? themeCtx.theme || "" : _c;
    if (!themes$4.has(theme)) {
        theme = "";
    }
    styleBuilder$4
        .setTheme(theme)
        .setElementClassNames(className)
        .setAppendedClassNames(appendClassNames)
        .setDisabled(disabled)
        .setSize(size);
    var elementClassNames = styleBuilder$4.buildElement();
    return (React.createElement(Base, __assign({ type: "number", className: elementClassNames, style: style }, props)));
}

var M=[["Afghanistan","af","93"],["Albania","al","355"],["Algeria","dz","213"],["Andorra","ad","376"],["Angola","ao","244"],["Antigua and Barbuda","ag","1268"],["Argentina","ar","54","(..) ........",0],["Armenia","am","374",".. ......"],["Aruba","aw","297"],["Australia","au","61",{default:". .... ....","/^4/":"... ... ...","/^5(?!50)/":"... ... ...","/^1(3|8)00/":".... ... ...","/^13/":".. .. ..","/^180/":"... ...."},0,[]],["Austria","at","43"],["Azerbaijan","az","994","(..) ... .. .."],["Bahamas","bs","1242"],["Bahrain","bh","973"],["Bangladesh","bd","880"],["Barbados","bb","1246"],["Belarus","by","375","(..) ... .. .."],["Belgium","be","32","... .. .. .."],["Belize","bz","501"],["Benin","bj","229"],["Bhutan","bt","975"],["Bolivia","bo","591"],["Bosnia and Herzegovina","ba","387"],["Botswana","bw","267"],["Brazil","br","55","(..) ........."],["British Indian Ocean Territory","io","246"],["Brunei","bn","673"],["Bulgaria","bg","359"],["Burkina Faso","bf","226"],["Burundi","bi","257"],["Cambodia","kh","855"],["Cameroon","cm","237"],["Canada","ca","1","(...) ...-....",1,["204","226","236","249","250","289","306","343","365","387","403","416","418","431","437","438","450","506","514","519","548","579","581","587","604","613","639","647","672","705","709","742","778","780","782","807","819","825","867","873","902","905"]],["Cape Verde","cv","238"],["Caribbean Netherlands","bq","599","",1],["Central African Republic","cf","236"],["Chad","td","235"],["Chile","cl","56"],["China","cn","86","... .... ...."],["Colombia","co","57","... ... ...."],["Comoros","km","269"],["Congo","cd","243"],["Congo","cg","242"],["Costa Rica","cr","506","....-...."],["C\xF4te d'Ivoire","ci","225",".. .. .. .. .."],["Croatia","hr","385"],["Cuba","cu","53"],["Cura\xE7ao","cw","599","",0],["Cyprus","cy","357",".. ......"],["Czech Republic","cz","420","... ... ..."],["Denmark","dk","45",".. .. .. .."],["Djibouti","dj","253"],["Dominica","dm","1767"],["Dominican Republic","do","1","",2],["Ecuador","ec","593"],["Egypt","eg","20"],["El Salvador","sv","503","....-...."],["Equatorial Guinea","gq","240"],["Eritrea","er","291"],["Estonia","ee","372",".... ......"],["Ethiopia","et","251"],["Fiji","fj","679"],["Finland","fi","358",".. ... .. .."],["France","fr","33",". .. .. .. .."],["French Guiana","gf","594"],["French Polynesia","pf","689"],["Gabon","ga","241"],["Gambia","gm","220"],["Georgia","ge","995"],["Germany","de","49",".... ........"],["Ghana","gh","233"],["Greece","gr","30"],["Grenada","gd","1473"],["Guadeloupe","gp","590","",0],["Guam","gu","1671"],["Guatemala","gt","502","....-...."],["Guinea","gn","224"],["Guinea-Bissau","gw","245"],["Guyana","gy","592"],["Haiti","ht","509","....-...."],["Honduras","hn","504"],["Hong Kong","hk","852",".... ...."],["Hungary","hu","36"],["Iceland","is","354","... ...."],["India","in","91",".....-....."],["Indonesia","id","62"],["Iran","ir","98","... ... ...."],["Iraq","iq","964"],["Ireland","ie","353",".. ......."],["Israel","il","972","... ... ...."],["Italy","it","39","... .......",0],["Jamaica","jm","1876"],["Japan","jp","81",".. .... ...."],["Jordan","jo","962"],["Kazakhstan","kz","7","... ...-..-..",0],["Kenya","ke","254"],["Kiribati","ki","686"],["Kosovo","xk","383"],["Kuwait","kw","965"],["Kyrgyzstan","kg","996","... ... ..."],["Laos","la","856"],["Latvia","lv","371",".. ... ..."],["Lebanon","lb","961"],["Lesotho","ls","266"],["Liberia","lr","231"],["Libya","ly","218"],["Liechtenstein","li","423"],["Lithuania","lt","370"],["Luxembourg","lu","352"],["Macau","mo","853"],["Macedonia","mk","389"],["Madagascar","mg","261"],["Malawi","mw","265"],["Malaysia","my","60","..-....-...."],["Maldives","mv","960"],["Mali","ml","223"],["Malta","mt","356"],["Marshall Islands","mh","692"],["Martinique","mq","596"],["Mauritania","mr","222"],["Mauritius","mu","230"],["Mexico","mx","52","... ... ....",0],["Micronesia","fm","691"],["Moldova","md","373","(..) ..-..-.."],["Monaco","mc","377"],["Mongolia","mn","976"],["Montenegro","me","382"],["Morocco","ma","212"],["Mozambique","mz","258"],["Myanmar","mm","95"],["Namibia","na","264"],["Nauru","nr","674"],["Nepal","np","977"],["Netherlands","nl","31",".. ........"],["New Caledonia","nc","687"],["New Zealand","nz","64","...-...-...."],["Nicaragua","ni","505"],["Niger","ne","227"],["Nigeria","ng","234"],["North Korea","kp","850"],["Norway","no","47","... .. ..."],["Oman","om","968"],["Pakistan","pk","92","...-......."],["Palau","pw","680"],["Palestine","ps","970"],["Panama","pa","507"],["Papua New Guinea","pg","675"],["Paraguay","py","595"],["Peru","pe","51"],["Philippines","ph","63",".... ......."],["Poland","pl","48","...-...-..."],["Portugal","pt","351"],["Puerto Rico","pr","1","",3,["787","939"]],["Qatar","qa","974"],["R\xE9union","re","262"],["Romania","ro","40"],["Russia","ru","7","(...) ...-..-..",1],["Rwanda","rw","250"],["Saint Kitts and Nevis","kn","1869"],["Saint Lucia","lc","1758"],["Saint Vincent and the Grenadines","vc","1784"],["Samoa","ws","685"],["San Marino","sm","378"],["S\xE3o Tom\xE9 and Pr\xEDncipe","st","239"],["Saudi Arabia","sa","966"],["Senegal","sn","221"],["Serbia","rs","381"],["Seychelles","sc","248"],["Sierra Leone","sl","232"],["Singapore","sg","65","....-...."],["Slovakia","sk","421"],["Slovenia","si","386"],["Solomon Islands","sb","677"],["Somalia","so","252"],["South Africa","za","27"],["South Korea","kr","82","... .... ...."],["South Sudan","ss","211"],["Spain","es","34","... ... ..."],["Sri Lanka","lk","94"],["Sudan","sd","249"],["Suriname","sr","597"],["Swaziland","sz","268"],["Sweden","se","46","... ... ..."],["Switzerland","ch","41",".. ... .. .."],["Syria","sy","963"],["Taiwan","tw","886"],["Tajikistan","tj","992"],["Tanzania","tz","255"],["Thailand","th","66"],["Timor-Leste","tl","670"],["Togo","tg","228"],["Tonga","to","676"],["Trinidad and Tobago","tt","1868"],["Tunisia","tn","216"],["Turkey","tr","90","... ... .. .."],["Turkmenistan","tm","993"],["Tuvalu","tv","688"],["Uganda","ug","256"],["Ukraine","ua","380","(..) ... .. .."],["United Arab Emirates","ae","971"],["United Kingdom","gb","44",".... ......"],["United States","us","1","(...) ...-....",0],["Uruguay","uy","598"],["Uzbekistan","uz","998",".. ... .. .."],["Vanuatu","vu","678"],["Vatican City","va","39",".. .... ....",1],["Venezuela","ve","58"],["Vietnam","vn","84"],["Yemen","ye","967"],["Zambia","zm","260"],["Zimbabwe","zw","263"]];var ve="react-international-phone-",ae=(...t)=>t.filter(e=>!!e).join(" ").trim(),xe=(...t)=>ae(...t).split(" ").map(e=>`${ve}${e}`).join(" "),P=({addPrefix:t,rawClassNames:e})=>ae(xe(...t),...e);var ie=({value:t,mask:e,maskSymbol:a,offset:i=0,trimNonMaskCharsLeftover:o=!1})=>{if(t.length<i)return t;let n=t.slice(0,i),c=t.slice(i),r=n,s=0;for(let l of e.split("")){if(s>=c.length){if(!o&&l!==a){r+=l;continue}break}l===a?(r+=c[s],s+=1):r+=l;}return r};var L=t=>t?/^\d+$/.test(t):!1;var F=t=>t.replace(/\D/g,"");var se=(t,e)=>{let a=t.style.display;a!=="block"&&(t.style.display="block");let i=t.getBoundingClientRect(),o=e.getBoundingClientRect(),n=o.top-i.top,c=i.bottom-o.bottom;n>=0&&c>=0||(Math.abs(n)<Math.abs(c)?t.scrollTop+=n:t.scrollTop-=c),t.style.display=a;};var ue=(t,e)=>{let a=e.disableDialCodeAndPrefix?!1:e.forceDialCode,i=e.disableDialCodeAndPrefix?!1:e.insertDialCodeOnEmpty,o=t,n=l=>e.trimNonDigitsEnd?l.trim():l;if(!o)return i&&!o.length||a?n(`${e.prefix}${e.dialCode}${e.charAfterDialCode}`):n(o);if(o=F(o),o===e.dialCode&&!e.disableDialCodeAndPrefix)return n(`${e.prefix}${e.dialCode}${e.charAfterDialCode}`);if(e.dialCode.startsWith(o)&&!e.disableDialCodeAndPrefix)return n(a?`${e.prefix}${e.dialCode}${e.charAfterDialCode}`:`${e.prefix}${o}`);if(!o.startsWith(e.dialCode)&&!e.disableDialCodeAndPrefix){if(a)return n(`${e.prefix}${e.dialCode}${e.charAfterDialCode}`);if(o.length<e.dialCode.length)return n(`${e.prefix}${o}`)}let c=()=>{let l=e.dialCode.length,u=o.slice(0,l),b=o.slice(l);return {phoneLeftSide:u,phoneRightSide:b}},{phoneLeftSide:r,phoneRightSide:s}=c();return r=`${e.prefix}${r}${e.charAfterDialCode}`,s=ie({value:s,mask:e.mask,maskSymbol:e.maskChar,trimNonMaskCharsLeftover:e.trimNonDigitsEnd||e.disableDialCodeAndPrefix&&s.length===0}),e.disableDialCodeAndPrefix&&(r=""),n(`${r}${s}`)};var de=({phoneBeforeInput:t,phoneAfterInput:e,phoneAfterFormatted:a,cursorPositionAfterInput:i,leftOffset:o=0,deletion:n})=>{if(i<o)return o;if(!t)return a.length;let c=null;for(let u=i-1;u>=0;u-=1)if(L(e[u])){c=u;break}if(c===null){for(let u=0;u<e.length;u+=1)if(L(a[u]))return u;return e.length}let r=0;for(let u=0;u<c;u+=1)L(e[u])&&(r+=1);let s=0,l=0;for(let u=0;u<a.length&&(s+=1,L(a[u])&&(l+=1),!(l>=r+1));u+=1);if(n!=="backward")for(;!L(a[s])&&s<a.length;)s+=1;return s};var V=({phone:t,prefix:e})=>t?`${e}${F(t)}`:"";function O({value:t,country:e,insertDialCodeOnEmpty:a,trimNonDigitsEnd:i,countries:o,prefix:n,charAfterDialCode:c,forceDialCode:r,disableDialCodeAndPrefix:s,defaultMask:l,countryGuessingEnabled:u,disableFormatting:b}){let f=t;s&&(f=f.startsWith(`${n}`)?f:`${n}${e.dialCode}${f}`);let h=u?Z({phone:f,countries:o,currentCountryIso2:e?.iso2}):void 0,y=h?.country??e,p=ue(f,{prefix:n,mask:J({phone:f,country:y,defaultMask:l,disableFormatting:b}),maskChar:U,dialCode:y.dialCode,trimNonDigitsEnd:i,charAfterDialCode:c,forceDialCode:r,insertDialCodeOnEmpty:a,disableDialCodeAndPrefix:s}),g=u&&!h?.fullDialCodeMatch?e:y;return {phone:V({phone:s?`${g.dialCode}${p}`:p,prefix:n}),inputValue:p,country:g}}var De=t=>{if(t?.toLocaleLowerCase().includes("delete")??!1)return t?.toLocaleLowerCase().includes("forward")?"forward":"backward"},ce=(t,{country:e,insertDialCodeOnEmpty:a,phoneBeforeInput:i,prefix:o,charAfterDialCode:n,forceDialCode:c,disableDialCodeAndPrefix:r,countryGuessingEnabled:s,defaultMask:l,disableFormatting:u,countries:b})=>{let f=t.nativeEvent,h=f.inputType,y=De(h),p=!!h?.startsWith("insertFrom"),g=h==="insertText",x=f?.data||void 0,S=t.target.value,d=t.target.selectionStart??0;if(h?.includes("history"))return {inputValue:i,phone:V({phone:i,prefix:o}),cursorPosition:i.length,country:e};if(g&&!L(x)&&S!==o)return {inputValue:i,phone:V({phone:r?`${e.dialCode}${i}`:i,prefix:o}),cursorPosition:d-(x?.length??0),country:e};if(c&&!S.startsWith(`${o}${e.dialCode}`)&&!p){let N=S?i:`${o}${e.dialCode}${n}`;return {inputValue:N,phone:V({phone:N,prefix:o}),cursorPosition:o.length+e.dialCode.length+n.length,country:e}}let{phone:C,inputValue:m,country:v}=O({value:S,country:e,trimNonDigitsEnd:y==="backward",insertDialCodeOnEmpty:a,countryGuessingEnabled:s,countries:b,prefix:o,charAfterDialCode:n,forceDialCode:c,disableDialCodeAndPrefix:r,disableFormatting:u,defaultMask:l}),D=de({cursorPositionAfterInput:d,phoneBeforeInput:i,phoneAfterInput:S,phoneAfterFormatted:m,leftOffset:c?o.length+e.dialCode.length+n.length:0,deletion:y});return {phone:C,inputValue:m,cursorPosition:D,country:v}};var pe=(t,e)=>{let a=Object.keys(t),i=Object.keys(e);if(a.length!==i.length)return !1;for(let o of a)if(t[o]!==e[o])return !1;return !0};var fe=()=>{let t=useRef(),e=useRef(Date.now());return {check:()=>{let i=Date.now(),o=t.current?i-e.current:void 0;return t.current=e.current,e.current=i,o}}};var ke={size:20,overrideLastItemDebounceMS:-1};function he(t,e){let{size:a,overrideLastItemDebounceMS:i,onChange:o}={...ke,...e},[n,c]=useState(t),[r,s]=useState([n]),[l,u]=useState(0),b=fe();return [n,(p,g)=>{if(typeof p=="object"&&typeof n=="object"&&pe(p,n)||p===n)return;let A=i>0,x=b.check(),S=A&&x!==void 0?x>i:!0;if(g?.overrideLastItem!==void 0?g.overrideLastItem:!S)s(C=>[...C.slice(0,l),p]);else {let C=r.length>=a;s(m=>[...m.slice(C?1:0,l+1),p]),C||u(m=>m+1);}c(p),o?.(p);},()=>{if(l<=0)return {success:!1};let p=r[l-1];return c(p),u(g=>g-1),o?.(p),{success:!0,value:p}},()=>{if(l+1>=r.length)return {success:!1};let p=r[l+1];return c(p),u(g=>g+1),o?.(p),{success:!0,value:p}}]}var U=".",_={defaultCountry:"us",value:"",prefix:"+",defaultMask:"............",charAfterDialCode:" ",historySaveDebounceMS:200,disableCountryGuess:!1,disableDialCodePrefill:!1,forceDialCode:!1,disableDialCodeAndPrefix:!1,disableFormatting:!1,countries:M},X=({defaultCountry:t=_.defaultCountry,value:e=_.value,countries:a=_.countries,prefix:i=_.prefix,defaultMask:o=_.defaultMask,charAfterDialCode:n=_.charAfterDialCode,historySaveDebounceMS:c=_.historySaveDebounceMS,disableCountryGuess:r=_.disableCountryGuess,disableDialCodePrefill:s=_.disableDialCodePrefill,forceDialCode:l=_.forceDialCode,disableDialCodeAndPrefix:u=_.disableDialCodeAndPrefix,disableFormatting:b=_.disableFormatting,onChange:f,inputRef:h})=>{let g={countries:a,prefix:i,charAfterDialCode:n,forceDialCode:u?!1:l,disableDialCodeAndPrefix:u,defaultMask:o,countryGuessingEnabled:!r,disableFormatting:b},A=useRef(null),x=h||A,S=w=>{Promise.resolve().then(()=>{typeof window>"u"||x.current!==document?.activeElement||x.current?.setSelectionRange(w,w);});},[{phone:d,inputValue:C,country:m},v,D,N]=he(()=>{let w=T({value:t,field:"iso2",countries:a});w||console.error(`[react-international-phone]: can not find a country with "${t}" iso2 code`);let k=w||T({value:"us",field:"iso2",countries:a}),{phone:I,inputValue:$,country:B}=O({value:e,country:k,insertDialCodeOnEmpty:!s,...g});return S($.length),{phone:I,inputValue:$,country:B.iso2}},{overrideLastItemDebounceMS:c,onChange:({inputValue:w,phone:k,country:I})=>{if(!f)return;let $=E(I);f({phone:k,inputValue:w,country:$});}}),E=useCallback(w=>T({value:w,field:"iso2",countries:a}),[a]),H=useMemo(()=>E(m),[m,E]);useEffect(()=>{let w=x.current;if(!w)return;let k=I=>{if(!I.key)return;let $=I.ctrlKey,B=I.shiftKey,Pe=I.key.toLowerCase()==="z";!$||!Pe||(B?N():D());};return w.addEventListener("keydown",k),()=>{w.removeEventListener("keydown",k);}},[x,D,N]);let q=w=>{w.preventDefault();let{phone:k,inputValue:I,country:$,cursorPosition:B}=ce(w,{country:H,phoneBeforeInput:C,insertDialCodeOnEmpty:!1,...g});return v({inputValue:I,phone:k,country:$.iso2}),S(B),e},z=w=>{let k=T({value:w,field:"iso2",countries:a});if(!k){console.error(`[react-international-phone]: can not find a country with "${w}" iso2 code`);return}let I=u?"":`${i}${k.dialCode}${n}`;v({inputValue:I,phone:`${i}${k.dialCode}`,country:k.iso2}),Promise.resolve().then(()=>{x.current?.focus();});},[be,we]=useState(!1);return useEffect(()=>{if(!be){we(!0),e!==d&&f?.({inputValue:C,phone:d,country:H});return}if(e===d)return;let{phone:w,inputValue:k,country:I}=O({value:e,country:H,insertDialCodeOnEmpty:!s,...g});v({phone:w,inputValue:k,country:I.iso2});},[e]),{phone:d,inputValue:C,country:H,setCountry:z,handlePhoneValueChange:q,inputRef:x}};var J=({phone:t,country:e,defaultMask:a="............",disableFormatting:i=!1})=>{let o=e.format,n=r=>i?r.replace(new RegExp(`[^${U}]`,"g"),""):r;if(!o)return n(a);if(typeof o=="string")return n(o);if(!o.default)return console.error(`[react-international-phone]: default mask for ${e.iso2} is not provided`),n(a);let c=Object.keys(o).find(r=>{if(r==="default")return !1;if(!(r.charAt(0)==="/"&&r.charAt(r.length-1)==="/"))return console.error(`[react-international-phone]: format regex "${r}" for ${e.iso2} is not valid`),!1;let l=new RegExp(r.substring(1,r.length-1)),u=t.replace(e.dialCode,"");return l.test(F(u))});return n(c?o[c]:o.default)};var R=t=>{let[e,a,i,o,n,c]=t;return {name:e,iso2:a,dialCode:i,format:o,priority:n,areaCodes:c}};var Ae=t=>`Field "${t}" is not supported`,T=({field:t,value:e,countries:a=M})=>{if(["priority"].includes(t))throw new Error(Ae(t));let i=a.find(o=>{let n=R(o);return e===n[t]});if(i)return R(i)};var Z=({phone:t,countries:e=M,currentCountryIso2:a})=>{let i={country:void 0,fullDialCodeMatch:!1};if(!t)return i;let o=F(t);if(!o)return i;let n=i,c=({country:r,fullDialCodeMatch:s})=>{let l=r.dialCode===n.country?.dialCode,u=(r.priority??0)<(n.country?.priority??0);(!l||u)&&(n={country:r,fullDialCodeMatch:s});};for(let r of e){let s=R(r),{dialCode:l,areaCodes:u}=s;if(o.startsWith(l)){let b=n.country?Number(l)>=Number(n.country.dialCode):!0;if(u){let f=o.substring(l.length);for(let h of u)if(f.startsWith(h))return {country:s,fullDialCodeMatch:!0}}(b||l===o||!n.fullDialCodeMatch)&&c({country:s,fullDialCodeMatch:!0});}n.fullDialCodeMatch||o.length<l.length&&l.startsWith(o)&&(!n.country||Number(l)<=Number(n.country.dialCode))&&c({country:s,fullDialCodeMatch:!1});}if(a){let r=T({value:a,field:"iso2",countries:e});if(!r)return n;let l=r?(b=>{if(!b?.areaCodes)return !1;let f=o.substring(b.dialCode.length);return b.areaCodes.some(h=>h.startsWith(f))})(r):!1;!!n&&n.country?.dialCode===r.dialCode&&n.country!==r&&n.fullDialCodeMatch&&(!r.areaCodes||l)&&(n={country:r,fullDialCodeMatch:!0});}return n};var _e=(t,e)=>{let a=parseInt(t,16);return Number(a+e).toString(16)},Te="abcdefghijklmnopqrstuvwxyz",Ee="1f1e6",ge=Te.split("").reduce((t,e,a)=>({...t,[e]:_e(Ee,a)}),{}),$e=t=>[ge[t[0]],ge[t[1]]].join("-"),K=({iso2:t,size:e,src:a,protocol:i="https",disableLazyLoading:o,className:n,style:c,...r})=>{if(!t)return React__default.createElement("img",{className:P({addPrefix:["flag-emoji"],rawClassNames:[n]}),width:e,height:e,...r});let s=()=>{if(a)return a;let l=$e(t);return `${i}://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/${l}.svg`};return React__default.createElement("img",{className:P({addPrefix:["flag-emoji"],rawClassNames:[n]}),src:s(),width:e,height:e,draggable:!1,"data-country":t,loading:o?void 0:"lazy",style:{width:e,height:e,...c},alt:"",...r})};var Fe=1e3,oe=({show:t,dialCodePrefix:e="+",selectedCountry:a,countries:i=M,flags:o,onSelect:n,onClose:c,...r})=>{let s=useRef(null),l=useRef(),u=useRef({updatedAt:void 0,value:""}),b=d=>{let C=u.current.updatedAt&&new Date().getTime()-u.current.updatedAt.getTime()>Fe;u.current={value:C?d:`${u.current.value}${d}`,updatedAt:new Date};let m=i.findIndex(v=>R(v).name.toLowerCase().startsWith(u.current.value));m!==-1&&y(m);},f=useCallback(d=>i.findIndex(C=>R(C).iso2===d),[i]),[h,y]=useState(f(a)),p=()=>{l.current!==a&&y(f(a));},g=useCallback(d=>{y(f(d.iso2)),n?.(d);},[n,f]),A=d=>{let C=i.length-1,m=v=>d==="prev"?v-1:d==="next"?v+1:d==="last"?C:0;y(v=>{let D=m(v);return D<0?0:D>C?C:D});},x=d=>{if(d.stopPropagation(),d.key==="Enter"){d.preventDefault();let C=R(i[h]);g(C);return}if(d.key==="Escape"){c?.();return}if(d.key==="ArrowUp"){d.preventDefault(),A("prev");return}if(d.key==="ArrowDown"){d.preventDefault(),A("next");return}if(d.key==="PageUp"){d.preventDefault(),A("first");return}if(d.key==="PageDown"){d.preventDefault(),A("last");return}d.key===" "&&d.preventDefault(),d.key.length===1&&!d.altKey&&!d.ctrlKey&&!d.metaKey&&b(d.key.toLocaleLowerCase());},S=useCallback(()=>{if(!s.current||h===void 0)return;let d=R(i[h]).iso2;if(d===l.current)return;let C=s.current.querySelector(`[data-country="${d}"]`);C&&(se(s.current,C),l.current=d);},[h,i]);return useEffect(()=>{S();},[h,S]),useEffect(()=>{s.current&&(t?s.current.focus():p());},[t]),useEffect(()=>{p();},[a]),React__default.createElement("ul",{ref:s,role:"listbox",className:P({addPrefix:["country-selector-dropdown"],rawClassNames:[r.className]}),style:{display:t?"block":"none",...r.style},onKeyDown:x,onBlur:c,tabIndex:-1,"aria-activedescendant":`react-international-phone__${R(i[h]).iso2}-option`},i.map((d,C)=>{let m=R(d),v=m.iso2===a,D=C===h,N=o?.find(E=>E.iso2===m.iso2);return React__default.createElement("li",{key:m.iso2,"data-country":m.iso2,role:"option","aria-selected":v,"aria-label":`${m.name} ${e}${m.dialCode}`,id:`react-international-phone__${m.iso2}-option`,className:P({addPrefix:["country-selector-dropdown__list-item",v&&"country-selector-dropdown__list-item--selected",D&&"country-selector-dropdown__list-item--focused"],rawClassNames:[r.listItemClassName]}),onClick:()=>g(m),style:r.listItemStyle,title:m.name},React__default.createElement(K,{iso2:m.iso2,src:N?.src,className:P({addPrefix:["country-selector-dropdown__list-item-flag-emoji"],rawClassNames:[r.listItemFlagClassName]}),style:r.listItemFlagStyle}),React__default.createElement("span",{className:P({addPrefix:["country-selector-dropdown__list-item-country-name"],rawClassNames:[r.listItemCountryNameClassName]}),style:r.listItemCountryNameStyle},m.name),React__default.createElement("span",{className:P({addPrefix:["country-selector-dropdown__list-item-dial-code"],rawClassNames:[r.listItemDialCodeClassName]}),style:r.listItemDialCodeStyle},e,m.dialCode))}))};var re=({selectedCountry:t,onSelect:e,disabled:a,hideDropdown:i,countries:o=M,flags:n,renderButtonWrapper:c,...r})=>{let[s,l]=useState(!1),u=useMemo(()=>{if(t)return T({value:t,field:"iso2",countries:o})},[o,t]),b=useRef(null),f=y=>{y.key&&["ArrowUp","ArrowDown"].includes(y.key)&&(y.preventDefault(),l(!0));},h=()=>{let y={title:u?.name,onClick:()=>l(g=>!g),onMouseDown:g=>g.preventDefault(),onKeyDown:f,disabled:i||a,role:"combobox","aria-label":"Country selector","aria-haspopup":"listbox","aria-expanded":s},p=React__default.createElement("div",{className:P({addPrefix:["country-selector-button__button-content"],rawClassNames:[r.buttonContentWrapperClassName]}),style:r.buttonContentWrapperStyle},React__default.createElement(K,{iso2:t,src:n?.find(g=>g.iso2===t)?.src,className:P({addPrefix:["country-selector-button__flag-emoji",a&&"country-selector-button__flag-emoji--disabled"],rawClassNames:[r.flagClassName]}),style:{visibility:t?"visible":"hidden",...r.flagStyle}}),!i&&React__default.createElement("div",{className:P({addPrefix:["country-selector-button__dropdown-arrow",a&&"country-selector-button__dropdown-arrow--disabled",s&&"country-selector-button__dropdown-arrow--active"],rawClassNames:[r.dropdownArrowClassName]}),style:r.dropdownArrowStyle}));return c?c({children:p,rootProps:y}):React__default.createElement("button",{...y,type:"button",className:P({addPrefix:["country-selector-button",s&&"country-selector-button--active",a&&"country-selector-button--disabled",i&&"country-selector-button--hide-dropdown"],rawClassNames:[r.buttonClassName]}),"data-country":t,style:r.buttonStyle},p)};return React__default.createElement("div",{className:P({addPrefix:["country-selector"],rawClassNames:[r.className]}),style:r.style,ref:b},h(),React__default.createElement(oe,{show:s,countries:o,flags:n,onSelect:y=>{l(!1),e?.(y);},selectedCountry:t,onClose:()=>{l(!1);},...r.dropdownStyleProps}))};var ne=({dialCode:t,prefix:e,disabled:a,style:i,className:o})=>React__default.createElement("div",{className:P({addPrefix:["dial-code-preview",a&&"dial-code-preview--disabled"],rawClassNames:[o]}),style:i},`${e}${t}`);forwardRef(({value:t,onChange:e,countries:a=M,hideDropdown:i,showDisabledDialCodeAndPrefix:o,flags:n,style:c,className:r,inputStyle:s,inputClassName:l,countrySelectorStyleProps:u,dialCodePreviewStyleProps:b,inputProps:f,placeholder:h,disabled:y,name:p,onFocus:g,onBlur:A,required:x,autoFocus:S,...d},C)=>{let{phone:m,inputValue:v,inputRef:D,country:N,setCountry:E,handlePhoneValueChange:H}=X({value:t,countries:a,...d,onChange:z=>{e?.(z.phone,{country:z.country,inputValue:z.inputValue});}}),q=d.disableDialCodeAndPrefix&&o&&N?.dialCode;return useImperativeHandle(C,()=>D.current?Object.assign(D.current,{setCountry:E,state:{phone:m,inputValue:v,country:N}}):null,[D,E,m,v,N]),React__default.createElement("div",{ref:C,className:P({addPrefix:["input-container"],rawClassNames:[r]}),style:c},React__default.createElement(re,{onSelect:z=>E(z.iso2),flags:n,selectedCountry:N.iso2,countries:a,disabled:y,hideDropdown:i,...u}),q&&React__default.createElement(ne,{dialCode:N.dialCode,prefix:d.prefix??"+",disabled:y,...b}),React__default.createElement("input",{onChange:H,value:v,type:"tel",ref:D,className:P({addPrefix:["input",y&&"input--disabled"],rawClassNames:[l]}),placeholder:h,disabled:y,style:s,name:p,onFocus:g,onBlur:A,autoFocus:S,required:x,...f}))});

var css_248z$1 = ".react-international-phone-country-selector{position:relative}.react-international-phone-country-selector-button{display:flex;height:var(--react-international-phone-height, 36px);box-sizing:border-box;align-items:center;justify-content:center;padding:0;border:1px solid var(--react-international-phone-country-selector-border-color, var(--react-international-phone-border-color, gainsboro));margin:0;-moz-appearance:button;appearance:button;-webkit-appearance:button;background-color:var(--react-international-phone-country-selector-background-color, var(--react-international-phone-background-color, white));cursor:pointer;text-transform:none;-webkit-user-select:none;-moz-user-select:none;user-select:none}.react-international-phone-country-selector-button:hover{background-color:var(--react-international-phone-country-selector-background-color-hover, whitesmoke)}.react-international-phone-country-selector-button--hide-dropdown{cursor:auto}.react-international-phone-country-selector-button--hide-dropdown:hover{background-color:transparent}.react-international-phone-country-selector-button__button-content{display:flex;align-items:center;justify-content:center}.react-international-phone-country-selector-button__flag-emoji{margin:0 4px}.react-international-phone-country-selector-button__flag-emoji--disabled{opacity:.75}.react-international-phone-country-selector-button__dropdown-arrow{border-top:var(--react-international-phone-country-selector-arrow-size, 4px) solid var(--react-international-phone-country-selector-arrow-color, #777);border-right:var(--react-international-phone-country-selector-arrow-size, 4px) solid transparent;border-left:var(--react-international-phone-country-selector-arrow-size, 4px) solid transparent;margin-right:4px;transition:all .1s ease-out}.react-international-phone-country-selector-button__dropdown-arrow--active{transform:rotateX(180deg)}.react-international-phone-country-selector-button__dropdown-arrow--disabled{border-top-color:var(--react-international-phone-disabled-country-selector-arrow-color, #999)}.react-international-phone-country-selector-button--disabled{background-color:var(--react-international-phone-disabled-country-selector-background-color, var(--react-international-phone-disabled-background-color, whitesmoke));cursor:auto}.react-international-phone-country-selector-button--disabled:hover{background-color:var(--react-international-phone-disabled-country-selector-background-color, var(--react-international-phone-disabled-background-color, whitesmoke))}.react-international-phone-flag-emoji{width:var(--react-international-phone-flag-width, 24px);height:var(--react-international-phone-flag-height, 24px);box-sizing:border-box}.react-international-phone-country-selector-dropdown{position:absolute;z-index:1;top:var(--react-international-phone-dropdown-left, 44px);left:var(--react-international-phone-dropdown-left, 0);display:flex;width:300px;max-height:200px;flex-direction:column;padding:4px 0;margin:0;background-color:var(--react-international-phone-dropdown-item-background-color, var(--react-international-phone-background-color, white));box-shadow:var(--react-international-phone-dropdown-shadow, 2px 2px 16px rgba(0, 0, 0, .25));color:var(--react-international-phone-dropdown-item-text-color, var(--react-international-phone-text-color, #222));list-style:none;overflow-y:scroll}.react-international-phone-country-selector-dropdown__list-item{display:flex;min-height:var(--react-international-phone-dropdown-item-height, 28px);box-sizing:border-box;align-items:center;padding:2px 8px}.react-international-phone-country-selector-dropdown__list-item-flag-emoji{margin-right:8px}.react-international-phone-country-selector-dropdown__list-item-country-name{overflow:hidden;margin-right:8px;font-size:var(--react-international-phone-dropdown-item-font-size, 14px);text-overflow:ellipsis;white-space:nowrap}.react-international-phone-country-selector-dropdown__list-item-dial-code{color:var(--react-international-phone-dropdown-item-dial-code-color, gray);font-size:var(--react-international-phone-dropdown-item-font-size, 14px)}.react-international-phone-country-selector-dropdown__list-item:hover{background-color:var(--react-international-phone-selected-dropdown-item-background-color, var(--react-international-phone-selected-dropdown-item-background-color, whitesmoke));cursor:pointer}.react-international-phone-country-selector-dropdown__list-item--selected,.react-international-phone-country-selector-dropdown__list-item--focused{background-color:var(--react-international-phone-selected-dropdown-item-background-color, whitesmoke);color:var(--react-international-phone-selected-dropdown-item-text-color, var(--react-international-phone-text-color, #222))}.react-international-phone-country-selector-dropdown__list-item--selected .react-international-phone-country-selector-dropdown__list-item-dial-code,.react-international-phone-country-selector-dropdown__list-item--focused .react-international-phone-country-selector-dropdown__list-item-dial-code{color:var(--react-international-phone-selected-dropdown-item-dial-code-color, var(--react-international-phone-dropdown-item-dial-code-color, gray))}.react-international-phone-country-selector-dropdown__list-item--focused{background-color:var(--react-international-phone-selected-dropdown-item-background-color, var(--react-international-phone-selected-dropdown-item-background-color, whitesmoke))}.react-international-phone-dial-code-preview{display:flex;align-items:center;justify-content:center;padding:0 8px;border:1px solid var(--react-international-phone-dial-code-preview-border-color, var(--react-international-phone-border-color, gainsboro));margin-right:-1px;background-color:var(--react-international-phone-dial-code-preview-background-color, var(--react-international-phone-background-color, white));color:var(--react-international-phone-dial-code-preview-text-color, var(--react-international-phone-text-color, #222));font-size:var(--react-international-phone-dial-code-preview-font-size, var(--react-international-phone-font-size, 13px))}.react-international-phone-dial-code-preview--disabled{background-color:var(--react-international-phone-dial-code-preview-disabled-background-color, var(--react-international-phone-disabled-background-color, whitesmoke));color:var(--react-international-phone-dial-code-preview-disabled-text-color, var(--react-international-phone-disabled-text-color, #666))}.react-international-phone-input-container{display:flex}.react-international-phone-input-container .react-international-phone-country-selector-button{border-radius:var(--react-international-phone-border-radius, 4px);margin-right:-1px;border-bottom-right-radius:0;border-top-right-radius:0}.react-international-phone-input-container .react-international-phone-input{overflow:visible;height:var(--react-international-phone-height, 36px);box-sizing:border-box;padding:0 8px;border:1px solid var(--react-international-phone-border-color, gainsboro);border-radius:var(--react-international-phone-border-radius, 4px);margin:0;background-color:var(--react-international-phone-background-color, white);border-bottom-left-radius:0;border-top-left-radius:0;color:var(--react-international-phone-text-color, #222);font-family:inherit;font-size:var(--react-international-phone-font-size, 13px)}.react-international-phone-input-container .react-international-phone-input:focus{outline:none}.react-international-phone-input-container .react-international-phone-input--disabled{background-color:var(--react-international-phone-disabled-background-color, whitesmoke);color:var(--react-international-phone-disabled-text-color, #666)}\n";
styleInject(css_248z$1);

var css_248z = "button.react-international-phone-country-selector-button {\r\n  all: unset;\r\n}";
styleInject(css_248z);

var themes$3 = new Map();
var defaultTheme$3 = new Map();
defaultTheme$3.set("container", "flex flex-row rounded");
defaultTheme$3.set("element", "w-full border rounded-tr rounded-br outline outline-1 outline-slate-100");
defaultTheme$3.set("selector", "bg-white border flex justify-center items-center rounded-tl rounded-bl outline outline-1 outline-slate-100");
defaultTheme$3.set("disabled-true", "cursor-not-allowed");
defaultTheme$3.set("size-".concat(InputSize.LARGE), "px-2 py-3");
defaultTheme$3.set("size-".concat(InputSize.MEDIUM), "p-2");
var acsmTheme$1 = new Map();
acsmTheme$1.set("container", "flex flex-row rounded");
acsmTheme$1.set("element", "w-full border-b border-black placeholder:text-acsm-red font-verdana sm:!font-poppins");
acsmTheme$1.set("selector", "border border-t-transparent border-l-transparent border-r-transparent border-b-black flex justify-center items-center bg-white");
acsmTheme$1.set("disabled-true", "cursor-not-allowed");
acsmTheme$1.set("size-".concat(InputSize.LARGE), "px-2 py-3");
acsmTheme$1.set("size-".concat(InputSize.MEDIUM), "p-2");
var acem2Theme$3 = new Map();
acem2Theme$3.set("container", "flex flex-row rounded");
acem2Theme$3.set("element", "w-full border rounded-tr rounded-br outline outline-1 outline-acem2-asphalt");
acem2Theme$3.set("selector", "bg-white border flex justify-center items-center rounded-tl rounded-bl outline outline-1 outline-acem2-asphalt");
acem2Theme$3.set("disabled-true", "cursor-not-allowed");
acem2Theme$3.set("size-".concat(InputSize.LARGE), "px-2 py-3");
acem2Theme$3.set("size-".concat(InputSize.MEDIUM), "p-2");
themes$3.set("", defaultTheme$3);
themes$3.set(InputTheme.ACSMARINE, acsmTheme$1);
themes$3.set(InputTheme.ALLIEDCONTAINER2, acem2Theme$3);
var InputPhoneStyle = /** @class */ (function () {
    function InputPhoneStyle() {
        this.theme = "";
        this.disabled = false;
        this.size = "";
        this.elementClassNames = "";
        this.appendedClassNames = "";
    }
    InputPhoneStyle.prototype.buildContainer = function () {
        var style = undefined;
        var theme = themes$3.get(this.theme);
        if (!theme) {
            return style;
        }
        if (theme.has("container")) {
            style = theme.get("container");
        }
        return style;
    };
    InputPhoneStyle.prototype.buildElement = function () {
        var style = undefined;
        if (this.elementClassNames) {
            return this.elementClassNames;
        }
        var theme = themes$3.get(this.theme);
        if (!theme) {
            return style;
        }
        if (theme.has("element")) {
            style = theme.get("element");
        }
        if (theme.has("disabled-".concat(this.disabled))) {
            style += " " + theme.get("disabled-".concat(this.disabled));
        }
        if (theme.has("size-".concat(this.size))) {
            style += " " + theme.get("size-".concat(this.size));
        }
        if (this.appendedClassNames !== "") {
            style += " " + this.appendedClassNames;
        }
        return style;
    };
    InputPhoneStyle.prototype.buildSelector = function () {
        var style = undefined;
        var theme = themes$3.get(this.theme);
        if (!theme) {
            return style;
        }
        if (theme.has("selector")) {
            style = theme.get("selector");
        }
        if (theme.has("disabled-".concat(this.disabled))) {
            style += " " + theme.get("disabled-".concat(this.disabled));
        }
        if (theme.has("size-".concat(this.size))) {
            style += " " + theme.get("size-".concat(this.size));
        }
        return style;
    };
    InputPhoneStyle.prototype.setTheme = function (theme) {
        this.theme = theme;
        return this;
    };
    InputPhoneStyle.prototype.setDisabled = function (disabled) {
        this.disabled = disabled;
        return this;
    };
    InputPhoneStyle.prototype.setSize = function (size) {
        this.size = size;
        return this;
    };
    InputPhoneStyle.prototype.setElementClassNames = function (elementClassNames) {
        this.elementClassNames = elementClassNames;
        return this;
    };
    InputPhoneStyle.prototype.setAppendedClassNames = function (appendedClassNames) {
        this.appendedClassNames = appendedClassNames;
        return this;
    };
    return InputPhoneStyle;
}());
var styleBuilder$3 = new InputPhoneStyle();
function InputPhone(props) {
    var themeCtx = React.useContext(ThemeContext);
    var _a = props.defaultCountry, defaultCountry = _a === void 0 ? "sg" : _a, _b = props.disabled, disabled = _b === void 0 ? false : _b, _c = props.size, size = _c === void 0 ? InputSize.MEDIUM : _c, className = props.className, appendClassNames = props.appendClassNames;
    var _d = props.theme, theme = _d === void 0 ? themeCtx.theme || "" : _d;
    if (!themes$3.has(theme)) {
        theme = "";
    }
    styleBuilder$3
        .setTheme(theme)
        .setAppendedClassNames(appendClassNames)
        .setElementClassNames(className)
        .setDisabled(disabled)
        .setSize(size);
    var containerClassName = styleBuilder$3.buildContainer();
    var elementClassNames = styleBuilder$3.buildElement();
    var selectorClassNames = styleBuilder$3.buildSelector();
    var _e = X({
        defaultCountry: defaultCountry,
        disableFormatting: true,
        charAfterDialCode: "",
        value: props.value,
        onChange: function (data) {
            props.onUpdate && props.onUpdate({
                phone_number: data.phone
            });
        }
    }), inputValue = _e.inputValue, handlePhoneValueChange = _e.handlePhoneValueChange, country = _e.country, setCountry = _e.setCountry;
    var handleInput = function (e) {
        props.onInput && props.onInput(e);
    };
    var handleBlur = function (e) {
        props.onBlur && props.onBlur(e);
    };
    var handleCountrySelect = function (country) {
        setCountry(country.iso2);
        props.onUpdate && props.onUpdate({
            phone_number: "+".concat(country.dialCode)
        });
    };
    return (React.createElement("div", { className: containerClassName },
        React.createElement(re, { className: selectorClassNames, selectedCountry: country.iso2, onSelect: handleCountrySelect, disabled: props.disabled }),
        React.createElement(Base, { type: "tel", className: elementClassNames, onInput: handleInput, onChange: handlePhoneValueChange, onBlur: handleBlur, id: props.id, name: props.name, placeholder: props.placeholder, required: props.required, disabled: props.disabled, readOnly: props.readOnly, defaultValue: props.defaultValue, value: inputValue })));
}

var themes$2 = new Map();
var defaultTheme$2 = new Map();
defaultTheme$2.set("container", "flex flex-row rounded outline outline-1 outline-slate-100");
defaultTheme$2.set("element", "w-full border rounded-tl rounded-bl outline outline-1 outline-slate-100");
defaultTheme$2.set("toggler", "bg-white border rounded-tr rounded-br cursor-pointer");
defaultTheme$2.set("disabled-true", "cursor-not-allowed");
defaultTheme$2.set("size-".concat(InputSize.LARGE), "px-2 py-3");
defaultTheme$2.set("size-".concat(InputSize.MEDIUM), "p-2");
var acem2Theme$2 = new Map();
acem2Theme$2.set("container", "flex flex-row rounded outline outline-1 outline-acem2-asphalt");
acem2Theme$2.set("element", "w-full border rounded-tl rounded-bl outline outline-1 outline-acem2-asphalt");
acem2Theme$2.set("toggler", "bg-white border rounded-tr rounded-br cursor-pointer");
acem2Theme$2.set("disabled-true", "cursor-not-allowed");
acem2Theme$2.set("size-".concat(InputSize.LARGE), "px-2 py-3");
acem2Theme$2.set("size-".concat(InputSize.MEDIUM), "p-2");
themes$2.set("", defaultTheme$2);
themes$2.set(InputTheme.ALLIEDCONTAINER2, acem2Theme$2);
var InputSecretStyle = /** @class */ (function () {
    function InputSecretStyle() {
        this.theme = "";
        this.disabled = false;
        this.size = "";
        this.elementClassNames = "";
    }
    InputSecretStyle.prototype.buildContainer = function () {
        var style = undefined;
        var theme = themes$2.get(this.theme);
        if (!theme) {
            return style;
        }
        if (theme.has("container")) {
            style = theme.get("container");
        }
        return style;
    };
    InputSecretStyle.prototype.buildElement = function () {
        var style = undefined;
        if (this.elementClassNames) {
            return this.elementClassNames;
        }
        var theme = themes$2.get(this.theme);
        if (!theme) {
            return style;
        }
        if (theme.has("element")) {
            style = theme.get("element");
        }
        if (theme.has("disabled-".concat(this.disabled))) {
            style += " " + theme.get("disabled-".concat(this.disabled));
        }
        if (theme.has("size-".concat(this.size))) {
            style += " " + theme.get("size-".concat(this.size));
        }
        return style;
    };
    InputSecretStyle.prototype.buildToggler = function () {
        var style = undefined;
        var theme = themes$2.get(this.theme);
        if (!theme) {
            return style;
        }
        if (theme.has("toggler")) {
            style = theme.get("toggler");
        }
        if (theme.has("size-".concat(this.size))) {
            style += " " + theme.get("size-".concat(this.size));
        }
        return style;
    };
    InputSecretStyle.prototype.setTheme = function (theme) {
        this.theme = theme;
        return this;
    };
    InputSecretStyle.prototype.setDisabled = function (disabled) {
        this.disabled = disabled;
        return this;
    };
    InputSecretStyle.prototype.setSize = function (size) {
        this.size = size;
        return this;
    };
    InputSecretStyle.prototype.setElementClassNames = function (elementClassNames) {
        this.elementClassNames = elementClassNames;
        return this;
    };
    return InputSecretStyle;
}());
var styleBuilder$2 = new InputSecretStyle();
function InputSecret(props) {
    var themeCtx = React.useContext(ThemeContext);
    var _a = props.toggleAble, toggleAble = _a === void 0 ? false : _a, _b = props.disabled, disabled = _b === void 0 ? false : _b, _c = props.size, size = _c === void 0 ? InputSize.MEDIUM : _c, className = props.className;
    var _d = props.theme, theme = _d === void 0 ? themeCtx.theme || "" : _d;
    if (!themes$2.has(theme)) {
        theme = "";
    }
    styleBuilder$2
        .setTheme(theme)
        .setElementClassNames(className)
        .setDisabled(disabled)
        .setSize(size);
    var containerClassNames = styleBuilder$2.buildContainer();
    var elementClassNames = styleBuilder$2.buildElement();
    var togglerClassNames = styleBuilder$2.buildToggler();
    var _e = React.useState(false), show = _e[0], setShow = _e[1];
    var handleToggle = function () {
        if (!toggleAble) {
            return;
        }
        setShow(function (prevState) {
            return !prevState;
        });
    };
    return (React.createElement("div", { className: containerClassNames },
        React.createElement(Base, __assign({ type: show ? "text" : "password", className: elementClassNames }, props)),
        toggleAble &&
            React.createElement("div", { className: togglerClassNames, onClick: handleToggle },
                !show &&
                    React.createElement(HiEye, { className: "w-6 h-6 text-gray-500" }),
                show &&
                    React.createElement(HiEyeSlash, { className: "w-6 h-6 text-gray-500" }))));
}

var themes$1 = new Map();
var defaultTheme$1 = new Map();
defaultTheme$1.set("container", "flex flex-row rounded outline outline-1 outline-slate-100");
defaultTheme$1.set("element-left", "w-full border rounded-tr rounded-br outline outline-1 outline-slate-100");
defaultTheme$1.set("element-right", "w-full border rounded-tl rounded-bl outline outline-1 outline-slate-100");
defaultTheme$1.set("action-left", "bg-white text-gray-500 border rounded-tl rounded-bl outline outline-1 outline-slate-100");
defaultTheme$1.set("action-right", "bg-white text-gray-500 border rounded-tr rounded-br outline outline-1 outline-slate-100");
defaultTheme$1.set("disabled-true", "cursor-not-allowed");
defaultTheme$1.set("size-".concat(InputSize.LARGE), "px-2 py-3");
defaultTheme$1.set("size-".concat(InputSize.MEDIUM), "p-2");
var acem2Theme$1 = new Map();
acem2Theme$1.set("container", "flex flex-row rounded outline outline-1 outline-acem2-asphalt");
acem2Theme$1.set("element-left", "w-full rounded-tr rounded-br");
acem2Theme$1.set("element-right", "w-full rounded-tl rounded-bl");
acem2Theme$1.set("action-left", "bg-white text-acem2-red rounded-tl rounded-bl");
acem2Theme$1.set("action-right", "bg-white text-acem2-red rounded-tr rounded-br");
acem2Theme$1.set("disabled-true", "cursor-not-allowed");
acem2Theme$1.set("size-".concat(InputSize.LARGE), "px-2 py-3");
acem2Theme$1.set("size-".concat(InputSize.MEDIUM), "p-2");
themes$1.set("", defaultTheme$1);
themes$1.set(InputTheme.ALLIEDCONTAINER2, acem2Theme$1);
var InputSearchStyle = /** @class */ (function () {
    function InputSearchStyle() {
        this.theme = "";
        this.disabled = false;
        this.size = "";
        this.actionPosition = "";
        this.elementClassNames = "";
    }
    InputSearchStyle.prototype.buildContainer = function () {
        var style = undefined;
        var theme = themes$1.get(this.theme);
        if (!theme) {
            return style;
        }
        if (theme.has("container")) {
            style = theme.get("container");
        }
        if (theme.has("disabled-".concat(this.disabled))) {
            style += " " + theme.get("disabled-".concat(this.disabled));
        }
        return style;
    };
    InputSearchStyle.prototype.buildElement = function () {
        var style = undefined;
        if (this.elementClassNames) {
            return this.elementClassNames;
        }
        var theme = themes$1.get(this.theme);
        if (!theme) {
            return style;
        }
        if (theme.has("element-".concat(this.actionPosition))) {
            style = " " + theme.get("element-".concat(this.actionPosition));
        }
        if (theme.has("size-".concat(this.size))) {
            style += " " + theme.get("size-".concat(this.size));
        }
        return style;
    };
    InputSearchStyle.prototype.buildAction = function () {
        var style = undefined;
        var theme = themes$1.get(this.theme);
        if (!theme) {
            return style;
        }
        if (theme.has("action-".concat(this.actionPosition))) {
            style = " " + theme.get("action-".concat(this.actionPosition));
        }
        if (theme.has("size-".concat(this.size))) {
            style += " " + theme.get("size-".concat(this.size));
        }
        return style;
    };
    InputSearchStyle.prototype.setTheme = function (theme) {
        this.theme = theme;
        return this;
    };
    InputSearchStyle.prototype.setDisabled = function (disabled) {
        this.disabled = disabled;
        return this;
    };
    InputSearchStyle.prototype.setSize = function (size) {
        this.size = size;
        return this;
    };
    InputSearchStyle.prototype.setActionPosition = function (actionPosition) {
        this.actionPosition = actionPosition;
        return this;
    };
    InputSearchStyle.prototype.setElementClassNames = function (elementClassNames) {
        this.elementClassNames = elementClassNames;
        return this;
    };
    return InputSearchStyle;
}());
var ActionPosition;
(function (ActionPosition) {
    ActionPosition["LEFT"] = "left";
    ActionPosition["RIGHT"] = "right";
})(ActionPosition || (ActionPosition = {}));
var styleBuilder$1 = new InputSearchStyle();
function InputSearch(props) {
    var themeCtx = React.useContext(ThemeContext);
    var _a = props.disabled, disabled = _a === void 0 ? false : _a, _b = props.showAction, showAction = _b === void 0 ? false : _b, _c = props.size, size = _c === void 0 ? InputSize.MEDIUM : _c, _d = props.actionPosition, actionPosition = _d === void 0 ? ActionPosition.RIGHT : _d, className = props.className;
    var _e = props.theme, theme = _e === void 0 ? themeCtx.theme || "" : _e;
    if (!themes$1.has(theme)) {
        theme = "";
    }
    styleBuilder$1
        .setTheme(theme)
        .setElementClassNames(className)
        .setActionPosition(actionPosition)
        .setDisabled(disabled)
        .setSize(size);
    var containerClassNames = styleBuilder$1.buildContainer();
    var actionClassNames = styleBuilder$1.buildAction();
    var elementClassNames = styleBuilder$1.buildElement();
    var handleSubmit = function () {
        props.onSubmit && props.onSubmit();
    };
    return (React.createElement("div", { className: containerClassNames },
        showAction && actionPosition === ActionPosition.LEFT &&
            React.createElement(ButtonSearch, { className: actionClassNames, onClick: handleSubmit }),
        React.createElement(Base, __assign({ type: "search", className: elementClassNames }, props)),
        showAction && actionPosition === ActionPosition.RIGHT &&
            React.createElement(ButtonSearch, { className: actionClassNames, onClick: handleSubmit })));
}
function ButtonSearch(props) {
    var className = props.className, onClick = props.onClick;
    return (React.createElement("button", { className: className, onClick: onClick },
        React.createElement(HiMagnifyingGlass, { className: "w-5 h-5" })));
}

var themes = new Map();
var defaultTheme = new Map();
defaultTheme.set("element", "w-full border rounded outline outline-1 outline-slate-100");
defaultTheme.set("disabled-true", "cursor-not-allowed");
defaultTheme.set("size-".concat(InputSize.LARGE), "px-2 py-3");
defaultTheme.set("size-".concat(InputSize.MEDIUM), "p-2");
var acsmTheme = new Map();
acsmTheme.set("element", "w-full border-b border-black placeholder:text-acsm-red font-verdana sm:!font-poppins");
acsmTheme.set("disabled-true", "cursor-not-allowed");
acsmTheme.set("size-".concat(InputSize.LARGE), "px-2 py-3");
acsmTheme.set("size-".concat(InputSize.MEDIUM), "p-2");
var acem2Theme = new Map();
acem2Theme.set("element", "w-full border rounded outline outline-1 outline-acem2-asphalt");
acem2Theme.set("disabled-true", "cursor-not-allowed");
acem2Theme.set("size-".concat(InputSize.LARGE), "px-2 py-3");
acem2Theme.set("size-".concat(InputSize.MEDIUM), "p-2");
themes.set("", defaultTheme);
themes.set(InputTheme.ACSMARINE, acsmTheme);
themes.set(InputTheme.ALLIEDCONTAINER2, acem2Theme);
var InputTextStyle = /** @class */ (function () {
    function InputTextStyle() {
        this.theme = "";
        this.disabled = false;
        this.size = "";
        this.elementClassNames = "";
        this.appendedClassNames = "";
    }
    InputTextStyle.prototype.buildElement = function () {
        var style = undefined;
        if (this.elementClassNames) {
            return this.elementClassNames;
        }
        var theme = themes.get(this.theme);
        if (!theme) {
            return style;
        }
        if (theme.has("element")) {
            style = theme.get("element");
        }
        if (theme.has("size-".concat(this.size))) {
            style += " " + theme.get("size-".concat(this.size));
        }
        if (theme.has("disabled-".concat(this.disabled))) {
            style += " " + theme.get("disabled-".concat(this.disabled));
        }
        if (this.appendedClassNames && this.appendedClassNames !== "") {
            style += " " + this.appendedClassNames;
        }
        return style;
    };
    InputTextStyle.prototype.setTheme = function (theme) {
        this.theme = theme;
        return this;
    };
    InputTextStyle.prototype.setDisabled = function (disabled) {
        this.disabled = disabled;
        return this;
    };
    InputTextStyle.prototype.setSize = function (size) {
        this.size = size;
        return this;
    };
    InputTextStyle.prototype.setElementClassNames = function (elementClassNames) {
        this.elementClassNames = elementClassNames;
        return this;
    };
    InputTextStyle.prototype.setAppendedClassNames = function (appendedClassNames) {
        this.appendedClassNames = appendedClassNames;
        return this;
    };
    return InputTextStyle;
}());
var styleBuilder = new InputTextStyle();
function InputText(props) {
    var themeCtx = React.useContext(ThemeContext);
    var _a = props.disabled, disabled = _a === void 0 ? false : _a, _b = props.size, size = _b === void 0 ? InputSize.MEDIUM : _b, appendClassNames = props.appendClassNames, className = props.className;
    var _c = props.theme, theme = _c === void 0 ? themeCtx.theme || "" : _c;
    if (!themes.has(theme)) {
        theme = "";
    }
    styleBuilder
        .setTheme(theme)
        .setElementClassNames(className)
        .setAppendedClassNames(appendClassNames)
        .setDisabled(disabled)
        .setSize(size);
    var elementClassNames = styleBuilder.buildElement();
    return (React.createElement(Base, __assign({ type: "text", className: elementClassNames }, props)));
}

export { InputCounter, InputEmail, InputNumber, InputPhone, InputSearch, InputSecret, InputText };
